import { format, unwrapFunctionStore } from 'svelte-i18n';

const $format = unwrapFunctionStore(format);

export const updatingSignature = {
  popover: {
    title: $format('label.TOURS.STUDIO.EDIT.UPDATING.TITLE'),
    description: $format('label.TOURS.STUDIO.EDIT.UPDATING.DESCRIPTION'),
    showButtons: ['next']
  }
};
